import { Container, decorate, injectable, inject } from 'inversify'
import 'reflect-metadata'

import contentClient from '@/axios/contentClient'
import mainClient from '@/axios/mainClient'

import AuthService from '@/services/AuthService'
import ActivityService from '@/services/ActivityService'
import ActivityGroupService from '@/services/ActivityGroupService'
import ActivityGroupActivityService from '@/services/ActivityGroupActivityService'
import MediaGroupService from '@/services/MediaGroupService'
import MediaService from '@/services/MediaService'
import RoomActivityService from '@/services/RoomActivityService'
import RoomActivityGroupService from '@/services/RoomActivityGroupService'
import RoomService from '@/services/RoomService'
import TagService from '@/services/TagService'
import WorkspaceService from '@/services/WorkspaceService'
import Api from '@/axios/Api'
import TokensManagerImpl from '@/core/auth/TokensManagerImpl'

import Tokens from './di.token'

decorate(injectable(), TokensManagerImpl)
decorate(injectable(), Api)
decorate(injectable(), AuthService)
decorate(injectable(), ActivityService)
decorate(injectable(), ActivityGroupService)
decorate(injectable(), ActivityGroupActivityService)
decorate(injectable(), MediaGroupService)
decorate(injectable(), MediaService)
decorate(injectable(), RoomActivityService)
decorate(injectable(), RoomActivityGroupService)
decorate(injectable(), RoomService)
decorate(injectable(), TagService)
decorate(injectable(), WorkspaceService)

decorate(inject(Tokens.MAIN_CLIENT), TokensManagerImpl, 0)
decorate(inject(Tokens.MAIN_CLIENT), AuthService, 0)
decorate(inject(Tokens.CONTENT_CLIENT), ActivityService, 0)
decorate(inject(Tokens.CONTENT_CLIENT), ActivityGroupService, 0)
decorate(inject(Tokens.CONTENT_CLIENT), ActivityGroupActivityService, 0)
decorate(inject(Tokens.CONTENT_CLIENT), MediaGroupService, 0)
decorate(inject(Tokens.CONTENT_CLIENT), MediaService, 0)
decorate(inject(Tokens.CONTENT_CLIENT), RoomActivityService, 0)
decorate(inject(Tokens.CONTENT_CLIENT), RoomActivityGroupService, 0)
decorate(inject(Tokens.CONTENT_CLIENT), RoomService, 0)
decorate(inject(Tokens.MAIN_CLIENT), WorkspaceService, 0)
decorate(
  inject(Tokens.ACTIVITY_GROUP_ACTIVITY_SERVICE),
  ActivityGroupService,
  1
)
decorate(inject(Tokens.ROOM_ACTIVITY_SERVICE), RoomService, 1)
decorate(inject(Tokens.ROOM_TO_ACTIVITY_GROUP_SERVICE), RoomService, 2)
decorate(inject(Tokens.CONTENT_CLIENT), TagService, 0)

const container = new Container({ skipBaseClassChecks: true })

container.bind(Tokens.TOKENS_MANAGER).to(TokensManagerImpl)
container.bind(Tokens.ACTIVITY_SERVICE).to(ActivityService)
container.bind(Tokens.ACTIVITY_GROUP_SERVICE).to(ActivityGroupService)
container
  .bind(Tokens.ACTIVITY_GROUP_ACTIVITY_SERVICE)
  .to(ActivityGroupActivityService)
container.bind(Tokens.MEDIA_GROUP_SERVICE).to(MediaGroupService)
container.bind(Tokens.MEDIA_SERVICE).to(MediaService)
container.bind(Tokens.WORKSPACE_SERVICE).to(WorkspaceService)
container.bind(Tokens.ROOM_SERVICE).to(RoomService)
container.bind(Tokens.AUTH_SERVICE).to(AuthService)
container.bind(Tokens.ROOM_ACTIVITY_SERVICE).to(RoomActivityService)
container
  .bind(Tokens.ROOM_TO_ACTIVITY_GROUP_SERVICE)
  .to(RoomActivityGroupService)
container.bind(Tokens.TAG_SERVICE).to(TagService)

container.bind(Tokens.CONTENT_CLIENT).toConstantValue(contentClient)
container.bind(Tokens.MAIN_CLIENT).toConstantValue(mainClient)

const contentApi = new Api(
  contentClient,
  container.get<TokensManagerImpl>(Tokens.TOKENS_MANAGER)
)

const mainApi = new Api(
  mainClient,
  container.get<TokensManagerImpl>(Tokens.TOKENS_MANAGER)
)

container.bind(Tokens.CONTENT_API).toConstantValue(contentApi)
container.bind(Tokens.MAIN_API).toConstantValue(mainApi)

export default container
